export const ACCOUNT_LOAD_RETRY_DELAY_MS = 500

export async function retryOnce<T>(load: () => Promise<T>, delayMs: number): Promise<T> {
  try {
    return await load()
  } catch {
    await new Promise<void>((resolve) => setTimeout(resolve, delayMs))
    return load()
  }
}
